import Vue from 'vue';
import VueRouter from 'vue-router';
import iView from 'view-design';
import Util from './libs/util';
import qs from 'qs'
/* Layout */
// 嵌入主体页面区分
let baseLayout, baseContent;
 const params = qs.parse(location.search.replace('?',''));
// const params = {
//     areaName: "奉贤区",
//     deptName: "市辖区-奉贤区",
//     loginType: "tenant",
//     permissions: "CyJjNBZnmgXDGGclDO+rDA==",
//     sessionMode: "BROWSER",
//     tenantAreaCode: "310120",
//     token: "69bab15250704e4dbf54c6dbeee81daa",
//     userId: "10215",
//     userName: "奉贤区管理员",
// }
console.log(params);
if(params.iframe === 'iframe'){
    baseLayout =  (resolve) => require(['./views/base/iframeBase.vue'], resolve);
    baseContent =  (resolve) => require(['./views/base/iframeBaseContent.vue'], resolve);
}else if (params.iframe === 'EAdministration') {
    baseLayout = (resolve) => require(['./views/base/LaBase.vue'], resolve);
    baseContent = (resolve) => require(['./views/base/baseContent.vue'], resolve);
} else {
    baseLayout = (resolve) => require(['./views/base/base.vue'], resolve);
    baseContent = (resolve) => require(['./views/base/baseContent.vue'], resolve);
}
// import baseLayout from './views/base/base.vue';
// import baseContent from './views/base/baseContent.vue';
import iframe from './views/base/iframe.vue';
import errorPage from './views/base/error404.vue';
import store from './store/store.js'

import { authLogin, thirdSsoLogin } from '@/api/user.js';
// 禁止全局路由错误处理打印，这个也是vue-router开发者给出的解决方案
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
    return originalPush.call(this, location).catch(err => err)
};
let homeComponent = '';
// console.log(9999999999999,process.env.VUE_APP_ENV)
if(process.env.VUE_APP_ENV === 'gaocheng'){
    //藁城
    homeComponent = (resolve) => require(['./views/supervise/chaffCityStatistics.vue'], resolve);
}else {
    homeComponent = (resolve) => require(['./views/supervise/statistics.vue'], resolve);
}

Vue.use(VueRouter);
export const routers = [
    {
        path: '*',
        component: errorPage,
        meta: {
            title:"404"
        }
    },
    {
        path: '/pdfView',
        name: 'pdfView',
        meta: {
            title: 'pdf文件预览',
        },
        component: (resolve) => require(['./views/base/pdfView.vue'], resolve)
    },
    {
        path: '/login',
        name: 'login',
        meta: {
            title: '建筑工人实名制管理系统-登录',
        },
        component: (resolve) => require(['./views/login.vue'], resolve)
    },
    // 门户页面
    {
        path: '/index',
        name: 'index',
        meta: {
            title: '建筑工人实名制管理系统'
        },
        component: (resolve) => require(['./views/login.vue'], resolve),
        children: [
            {
                path: 'portalHome',
                name: 'portalHome',
                component: (resolve) => require(['./views/portal/home/portalHome.vue'], resolve),
                meta: {
                    title:"建筑工人实名制管理系统-首页",
                }
            },
            {
                path: 'policiesAndRegulations',
                name: 'policiesAndRegulations',
                component: (resolve) => require(['./views/portal/home/policiesAndRegulations.vue'], resolve),
                meta: {
                    title:"建筑工人实名制管理系统-政策法规",
                }
            },
            {
                path: 'noticeAndAnnouncement',
                name: 'noticeAndAnnouncement',
                component: (resolve) => require(['./views/portal/home/policiesAndRegulations.vue'], resolve),
                meta: {
                    title:"建筑工人实名制管理系统-通知公告",
                }
            },
            {
                path: 'policiesAndRegulationsDetail',
                name: 'policiesAndRegulationsDetail',
                component: (resolve) => require(['./views/portal/home/policiesAndRegulationsDetail.vue'], resolve),
                meta: {
                    title:"建筑工人实名制管理系统-详情",
                }
            },

            {
                path: 'blackList',
                name: 'blackListp',
                component: (resolve) => require(['./views/portal/home/blackList.vue'], resolve),
                meta: {
                    title:"建筑工人实名制管理系统-黑名单",
                }
            },
            {
                path: 'blackListCorpDetail',
                name: 'blackListCorpDetail',
                component: (resolve) => require(['./views/portal/home/blackListCorpDetail.vue'], resolve),
                meta: {
                    title:"建筑工人实名制管理系统-企业黑名单详情",
                }
            },
            {
                path: 'blackListPersonDetail',
                name: 'blackListPersonDetail',
                component: (resolve) => require(['./views/portal/home/blackListPersonDetail.vue'], resolve),
                meta: {
                    title:"建筑工人实名制管理系统-个人黑名单详情",
                }
            },
            {
                path: 'creditScore',
                name: 'creditScore',
                component: (resolve) => require(['./views/portal/home/creditScore.vue'], resolve),
                meta: {
                    title:"建筑工人实名制管理系统-信用评分",
                }
            },
            {
                path: 'creditScoreDetail',
                name: 'creditScoreDetail',
                component: (resolve) => require(['./views/portal/home/creditScoreDetail.vue'], resolve),
                meta: {
                    title:"建筑工人实名制管理系统-信用评分详情",
                }
            },
            {
                path: 'creditInfo',
                name: 'creditInfop',
                component: (resolve) => require(['./views/portal/home/creditInfo.vue'], resolve),
                meta: {
                    title:"建筑工人实名制管理系统-诚信信息",
                }
            },
            {
                path: 'creditInfoDetail',
                name: 'creditInfoDetail',
                component: (resolve) => require(['./views/portal/home/creditInfoDetail.vue'], resolve),
                meta: {
                    title:"建筑工人实名制管理系统-诚信信息详情",
                }
            },
            {
                path: 'subletRegister',
                name:'subletRegister',
                component: (resolve) => require(['./views/portal/registForget/subletRegister.vue'], resolve),
                meta: {
                    title:"企业用户注册",
                }
            },
            {
                path: 'projectRegister',
                name:'projectRegister',
                component: (resolve) => require(['./views/portal/registForget/projectRegister.vue'], resolve),
                meta: {
                    title:"个人用户注册",
                }
            },
            {
                path: 'forgetPassword',
                name:'forgetPassword',
                component: (resolve) => require(['./views/portal/registForget/forgetPassword.vue'], resolve),
                meta: {
                    title:"忘记密码",
                }
            },
        ],
    },
    // 基础页面
    {
        name: 'base',
        path: '/',
        meta: {
            title: '建筑工人实名制管理系统',
            requiresAuth: true
        },
        component: baseLayout,
        children: [
            {
                name: 'iframeBase',
                path: '/iframeBase',
                meta: {
                    title: '建筑工人实名制管理系统',
                },
                component: baseContent,
                children: [
                    {
                        path: 'iframe/:path',
                        name:'iframe',
                        component: iframe,
                        meta: {
                            title:"子系统",
                        }
                    }
                ]
            },
            {
                path: 'changePassword',
                name:'changePassword',
                meta: {
                    title: '修改密码',
                },
                component: (resolve) => require(['./views/base/changePassword.vue'], resolve)
            }
        ],
    },
    // 项目实名制数据对接查询
    {
        path: "/projectDetailDockingQuery",
        name: "projectDetailDockingQuery",
        meta: {
            title: "项目实名制数据对接查询",
        },
        component: (resolve) =>
            require(["./views/base/projectDetailDockingQuery.vue"], resolve),
    },
];
export const asyncRouters = [
    // 用工实名监督
    {
        name: 'supervision',
        path: '/supervision',
        redirect:{
            name:'statistics'
        },
        meta: {
            title: '用工实名监督',
            requiresAuth: true
        },
        component: baseLayout,
        children: [
            // 统计分析
            {
                name: 'yzt',
                path: '/yzt',
                component: baseContent,
                redirect:{
                    name:'statistics'
                },
                meta: {
                    title:"统计分析",
                },
                children: [
                    {
                        name:'statistics',
                        path: 'statistics',
                        component:homeComponent,
                        // component: (resolve) => require(['./views/supervise/statistics.vue'], resolve),
                        // component:(resolve) => require(['./views/supervise/chaffCityStatistics.vue'], resolve),
                        meta: {
                            title:"统计分析",
                        }
                    },
                    {
                        path: 'projectList',
                        name:'sprojectList',
                        component: (resolve) => require(['./views/query/project/projectList.vue'], resolve),
                        meta: {
                            title:"施工项目查询",
                            pname:"statistics",
                            // keepAlive: true
                        }
                    },
                    {
                        path: 'unitList',
                        name:'sunitList',
                        component: (resolve) => require(['./views/query/unit/unitList.vue'], resolve),
                        meta: {
                            title:"参建单位查询",
                            pname:"statistics",
                            // keepAlive: true
                        }
                    },
                    {
                        path: 'personnelList',
                        name:'spersonnelList',
                        component: (resolve) => require(['./views/query/personnel/personnelList.vue'], resolve),
                        meta: {
                            title:"在册人员查询",
                            pname:"statistics",
                            // keepAlive: true
                        }
                    },
                    {
                        path: 'checking-inList',
                        name:'schecking-inList',
                        component: (resolve) => require(['./views/query/checking-in/checking-inList.vue'], resolve),
                        meta: {
                            title:"人员考勤查询",
                            pname:"statistics",
                            // keepAlive: true
                        }
                    },
                    {
                        path: 'education',
                        name:'seducation',
                        component: (resolve) => require(['./views/supervise/education/education.vue'], resolve),
                        meta: {
                            title:"教育培训监管",
                            pname:"statistics",
                            // keepAlive: true
                        }
                    },
                ]
            },
            // 综合监管
            {
                name: 'supervise',
                path: '/supervise',
                redirect:{
                    name:'workerAnalyze'
                },
                meta: {
                    title: '综合监管',
                },
                component: baseContent,
                children: [
                    {
                        path: 'workerAnalyze',
                        name:'workerAnalyze',
                        component: (resolve) => require(['./views/supervise/workerAnalyze/workerAnalyze.vue'], resolve),
                        meta: {
                            title:"人员属性分析",
                        }
                    },
                    {
                        path: 'workerCheck',
                        name:'workerCheck',
                        component: (resolve) => require(['./views/supervise/workerCheck/workerCheck.vue'], resolve),
                        meta: {
                            title:"人员出勤监管",
                        }
                    },
                    {
                        path: 'payoff',
                        name:'payoff',
                        component: (resolve) => require(['./views/supervise/payoff/payoff.vue'], resolve),
                        meta: {
                            title:"工资发放监管",
                        }
                    },
                    {
                        path: 'education',
                        name:'education',
                        component: (resolve) => require(['./views/supervise/education/education.vue'], resolve),
                        meta: {
                            title:"教育培训监管",
                        }
                    },
                    {
                        path: 'deposit',
                        name:'deposit',
                        component: (resolve) => require(['./views/supervise/deposit/deposit.vue'], resolve),
                        meta: {
                            title:"工资保证金",
                        }
                    },
                    {
                        path: 'account',
                        name:'account',
                        component: (resolve) => require(['./views/supervise/account/account.vue'], resolve),
                        meta: {
                            title:"工资专用账户",
                        }
                    }
                ],
            },
            // 综合查询
            {
                name: 'query',
                path: '/query',
                redirect:{
                    name:'projectList'
                },
                meta: {
                    title: '综合查询',
                },
                component: baseContent,
                children: [
                    {
                        path: 'exitRecordList',
                        name:'exitRecordList',
                        component: (resolve) => require(['./views/query/exitRecord/exitRecordList.vue'], resolve),
                        meta: {
                            title:"退场记录查询",
                            keepAlive: true
                        }
                    },
                    {
                        path: 'exitRecordDetail',
                        name:'exitRecordDetail',
                        component: (resolve) => require(['./views/query/exitRecord/exitRecordDetail.vue'], resolve),
                        meta: {
                            title:"退场记录查询",
                            pname:"exitRecordList",
                        }
                    },
                    {
                        path: 'projectList',
                        name:'projectList',
                        component: (resolve) => require(['./views/query/project/projectList.vue'], resolve),
                        meta: {
                            title:"施工项目查询",
                            keepAlive: true
                        }
                    },
                    {
                        path: 'projectDetail',
                        name:'projectDetail',
                        component: (resolve) => require(['./views/query/project/projectDetail.vue'], resolve),
                        meta: {
                            title:"施工项目详情",
                            pname:"projectList",
                        }
                    },
                    {
                        path: 'projectForm',
                        name: 'projectForm',
                        component: (resolve) => require(['./views/query/project/projectForm.vue'], resolve),
                        meta: {
                            title:'项目编辑',
                            pname:'projectList',
                        }
                    },
                    {
                        path: 'unitList',
                        name:'unitList',
                        component: (resolve) => require(['./views/query/unit/unitList.vue'], resolve),
                        meta: {
                            title:"参建单位查询",
                            keepAlive: true
                        }
                    },
                    {
                        path: 'unitDetail',
                        name:'unitDetail',
                        component: (resolve) => require(['./views/query/unit/unitDetail.vue'], resolve),
                        meta: {
                            title:"企业详情",
                            pname:"unitList",
                        }
                    },
                    {
                        path: 'personnelList',
                        name:'personnelList',
                        component: (resolve) => require(['./views/query/personnel/personnelList.vue'], resolve),
                        meta: {
                            title:"在册人员查询",
                            keepAlive: true
                        }
                    },
                    {
                        path:'postList',
                        name:'postList',
                        component:(resolve) => require(['./views/query/management/postList.vue'],resolve),
                         meta: {
                            title:"关键岗位人员查询",
                            keepAlive: true
                        }
                    },
                    {
                        path: 'personnelDetail',
                        name:'personnelDetail',
                        component: (resolve) => require(['./views/query/personnel/personnelDetail.vue'], resolve),
                        meta: {
                            title:"在册人员详情",
                            pname:'personnelList'
                        }
                    },
                    {
                        path: 'checking-inList',
                        name:'checking-inList',
                        component: (resolve) => require(['./views/query/checking-in/checking-inList.vue'], resolve),
                        meta: {
                            title:"人员考勤查询",
                            keepAlive: true
                        }
                    },{
                        path: 'checking-inDetail',
                        name:'checking-inDetail',
                        component: (resolve) => require(['./views/query/checking-in/checking-inDetail.vue'], resolve),
                        meta: {
                            title:"人员考勤详情",
                            pname:'checking-inList'
                        }
                    },
                    {
                        path: 'projectAttList',
                        name:'projectAttList',
                        component: (resolve) => require(['./views/query/projectAtt/projectAttList.vue'], resolve),
                        meta: {
                            title:"项目考勤查询",
                            keepAlive: true
                        }
                    },
                    {
                        path: 'workerWageList',
                        name:'workerWageList',
                        component: (resolve) => require(['./views/query/workerWage/workerWageList.vue'], resolve),
                        meta: {
                            title:"工人工资查询",
                            keepAlive: true
                        }
                    },
                    {
                        path: 'workerPayRollList/:id',
                        name: 'workerPayRollListT',
                        component: (resolve) => require(['./views/query/workerWage/workerPayRollList.vue'], resolve),
                        meta: {
                            title: "工资单查询",
                            pname: 'workerWageList'
                        }
                    },
                    {
                        path: 'workerPayRollList',
                        name:'workerPayRollList',
                        component: (resolve) => require(['./views/query/workerWage/workerPayRollList.vue'], resolve),
                        meta: {
                            title: "工资单查询",
                            keepAlive: true
                        }
                    },
                    {
                        path: 'workerWageDetail',
                        name:'workerWageDetail',
                        component: (resolve) => require(['./views/query/workerWage/workerWageDetail.vue'], resolve),
                        meta: {
                            title: "工人工资查询详情",
                            pname: 'workerWageList'
                        }
                    }
                ],
            },
            // 数据分析
            {
                name: 'dataAnalysis',
                path: '/dataAnalysis',
                redirect:{
                    name:'monitoringProjectAnalysis'
                },
                meta: {
                    title: '数据分析',
                },
                component: baseContent,
                children: [
                    {
                        path: 'monitoringProjectAnalysis',
                        name:'monitoringProjectAnalysis',
                        component: (resolve) => require(['./views/dataAnalysis/dataAnalysis/dataAnalysis.vue'], resolve),
                        meta: {
                            title:"监管项目统计-地市",
                            keepAlive: true
                        }
                    },
                    {
                        path: 'dataAnalysisDetail',
                        name:'dataAnalysisDetail',
                        component: (resolve) => require(['./views/dataAnalysis/dataAnalysis/dataAnalysisDetail.vue'], resolve),
                        meta: {
                            title:"监管项目统计-区县",
                            pname:"monitoringProjectAnalysis",
                        }
                    },
                    {
                        path: 'dataAnalysisDetailProject',
                        name:'dataAnalysisDetailProject',
                        component: (resolve) => require(['./views/dataAnalysis/dataAnalysis/dataAnalysisDetailProject.vue'], resolve),
                        meta: {
                            title:"监管项目统计",
                            pname:"monitoringProjectAnalysis",
                        }
                    },
                    {
                        path: 'dataFrom',
                        name:'dataFrom',
                        component: (resolve) => require(['./views/dataAnalysis/dataFrom/dataFrom.vue'], resolve),
                        meta: {
                            title:"数据来源",
                            keepAlive: true
                        }
                    },
                    {
                        path: 'dataFromDetail',
                        name:'dataFromDetail',
                        component: (resolve) => require(['./views/dataAnalysis/dataFrom/dataFromDetail.vue'], resolve),
                        meta: {
                            title:'数据来源详情',
                            pname:'dataFrom',
                        }
                    },
                    {
                        path:'participatingUnits',
                        name:'participatingUnits',
                        component: (resolve) => require(['./views/dataAnalysis/dataFrom/participatingUnits.vue'], resolve),
                        meta: {
                            title:'参建单位数据',
                            pname:'dataFrom',
                        }
                    },
                    {
                        path:'personData',
                        name:'personData',
                        component: (resolve) => require(['./views/dataAnalysis/dataFrom/personData.vue'], resolve),
                        meta: {
                            title:'人员数据',
                            pname:'dataFrom',
                        }
                    },
                    {
                        path:'PersonnelEntryExitData',
                        name:'PersonnelEntryExitData',
                        component: (resolve) => require(['./views/dataAnalysis/dataFrom/PersonnelEntryExitData.vue'], resolve),
                        meta: {
                            title:'项目人员进退场数据',
                            pname:'dataFrom',
                        }
                    },
                    {
                        path:'projectData',
                        name:'projectData',
                        component: (resolve) => require(['./views/dataAnalysis/dataFrom/projectData.vue'], resolve),
                        meta: {
                            title:'项目基本信息数据',
                            pname:'dataFrom',
                        }
                    },
                    {
                        path:'temaData',
                        name:'temaData',
                        component: (resolve) => require(['./views/dataAnalysis/dataFrom/temaData.vue'], resolve),
                        meta: {
                            title:'班组数据',
                            pname:'dataFrom',
                        }
                    },
                    {
                        path:'attendancePersonnel',
                        name:'attendancePersonnel',
                        component: (resolve) => require(['./views/dataAnalysis/dataFrom/attendancePersonnel.vue'], resolve),
                        meta: {
                            title:'项目人员考勤数据',
                            pname:'dataFrom',
                        }
                    },
                    {
                        path:'enterpriseData',
                        name:'enterpriseData',
                        component: (resolve) => require(['./views/dataAnalysis/dataFrom/enterpriseData.vue'], resolve),
                        meta: {
                            title:'企业数据',
                            pname:'dataFrom',
                        }
                    },
                    {
                        path:'projectPersonalContract',
                        name:'projectPersonalContract',
                        component: (resolve) => require(['./views/dataAnalysis/dataFrom/projectPersonalContract.vue'], resolve),
                        meta: {
                            title:'项目人员合同数据',
                            pname:'dataFrom',
                        }
                    },
                    {
                        path:'projectpersonnelSalary',
                        name:'projectpersonnelSalary',
                        component: (resolve) => require(['./views/dataAnalysis/dataFrom/projectpersonnelSalary.vue'], resolve),
                        meta: {
                            title:'项目人员工资数据',
                            pname:'dataFrom',
                        }
                    },
                    {
                        path:'projectTraining',
                        name:'projectTraining',
                        component: (resolve) => require(['./views/dataAnalysis/dataFrom/projectTraining.vue'], resolve),
                        meta: {
                            title:'项目培训数据',
                            pname:'dataFrom',
                        }
                    },
                    {
                        path: 'theWorkAnalysis',
                        name:'theWorkAnalysis',
                        component: (resolve) => require(['./views/query/theWorkAnalysis/theWorkAnalysis.vue'], resolve),
                        meta: {
                            title:"管理人员到岗统计",
                            keepAlive: true
                        }
                    },
                    {
                        path: 'theWorkAnalysisDetail',
                        name:'theWorkAnalysisDetail',
                        component: (resolve) => require(['./views/query/theWorkAnalysis/theWorkAnalysisDetail.vue'], resolve),
                        meta: {
                            title:"管理人员到岗统计",
                            pname:'theWorkAnalysis'
                        }
                    },
                    {
                        path: 'theWorkAnalysisDetailProject',
                        name:'theWorkAnalysisDetailProject',
                        component: (resolve) => require(['./views/query/theWorkAnalysis/theWorkAnalysisDetailProject.vue'], resolve),
                        meta: {
                            title:"管理人员到岗统计",
                            pname:'theWorkAnalysis'
                        }
                    },
                    {
                        path: 'postWarning',
                        name: 'postWarning',
                        component: (resolve) => require(['./views/query/postWarning/postWarning.vue'], resolve),
                        meta: {
                            title:"关键岗位预警",
                            keepAlive: true
                        }
                    },
                    {
                        path: 'postWarningDetail',
                        name: 'postWarningDetail',
                        component: (resolve) => require(['./views/query/postWarning/postWarningDetail.vue'], resolve),
                        meta: {
                            title:"关键岗位预警",
                            pname: 'postWarning'
                        }
                    },
                    {
                        path: 'postWarningDetailProject',
                        name: 'postWarningDetailProject',
                        component: (resolve) => require(['./views/query/postWarning/postWarningDetailProject.vue'], resolve),
                        meta: {
                            title:"关键岗位预警",
                            pname: 'postWarning'
                        }
                    },
                    {
                        path: 'dataPush',
                        name: 'dataPush',
                        component: (resolve) => require(['./views/query/dataPush/dataPush.vue'], resolve),
                        meta: {
                            title:"数据推送",
                            keepAlive: true
                        }
                    },
                    {
                        path: 'dataPushList',
                        name: 'dataPushList',
                        component: (resolve) => require(['./views/query/dataPush/dataPushList.vue'], resolve),
                        meta: {
                            title:"数据推送",
                            pname:'dataPush'
                        }
                    },
                    {
                        path: "trendAnalysis",
                        name: "trendAnalysis",
                        component: (resolve) =>
                            require(["./views/query/trendStatistics/trendStatisticsDetail.vue"], resolve),
                        meta: {
                            title: "趋势统计",
                            keepAlive: true,
                        },
                    }
                ],
            },
            // 权限管理
            {
                name: 'systemManagement',
                path: '/systemManagement',
                redirect:{
                    name:'userManagement'
                },
                meta: {
                    title: '权限管理',
                },
                component: baseContent,
                children: [
                    {
                        path: 'userManagement',
                        name:'userManagement',
                        component: (resolve) => require(['./views/system/user/userManageList.vue'], resolve),
                        meta: {
                            title:"用户管理",
                            keepAlive: true
                        }
                    },
                    {
                        path: 'userManageForm',
                        name:'userManageForm',
                        component: (resolve) => require(['./views/system/user/userManageForm.vue'], resolve),
                        meta: {
                            title:"用户管理",
                            pname:'userManageList',
                        }
                    },
                    {
                      path: "dataPush",
                      name: "dataPush",
                      component: (resolve) =>
                        require(["./views/system/dataPush/dataPush.vue"], resolve),
                      meta: {
                        title: "数据推送",
                        keepAlive: true,
                      },
                    },
                    {
                      path: "dataPushDetails",
                      name: "dataPushDetails",
                      component: (resolve) =>
                        require(["./views/system/dataPush/dataPushDetails.vue"], resolve),
                      meta: {
                        title: "推送详情",
                        pname: "dataPush",
                      },
                    },
                    {
                      path: "dataPushFrom",
                      name: "dataPushFrom",
                      component: (resolve) =>
                        require(["./views/system/dataPush/dataPushFrom.vue"], resolve),
                      meta: {
                        title: "数据推送",
                        pname: "dataPush",
                      },
                    },
                    {
                        path: "dataPushKey",
                        name: "dataPushKey",
                        component: (resolve) =>
                          require(["./views/system/dataPush/dataPushKey.vue"], resolve),
                        meta: {
                          title: "密钥管理",
                          pname: "dataPush",
                        },
                      },
                    {
                        path: "editProjectGdm",
                        name: "editProjectGdm",
                        component: (resolve) =>
                            require(["./views/system/dataPush/editProjectGdm.vue"], resolve),
                        meta: {
                            title: "编辑",
                            pname: "dataPush",
                        },
                    },
                    {
                        path: 'subletManageForm',
                        name:'subletManageForm',
                        component: (resolve) => require(['./views/system/user/subletManageForm.vue'], resolve),
                        meta: {
                            title:"企业用户修改",
                            pname:'userManageList',
                        }
                    },
                    {
                        path: 'projectManageForm',
                        name:'projectManageForm',
                        component: (resolve) => require(['./views/system/user/projectManageForm.vue'], resolve),
                        meta: {
                            title:"企业用户修改",
                            pname:'userManageList',
                        }
                    },
                    {
                        path: 'roleManagement',
                        name:'roleManagement',
                        component: (resolve) => require(['./views/system/role/roleManageList_back.vue'], resolve),
                        meta: {
                            title:"角色管理",
                            keepAlive: true
                        }
                    },
                    {
                        path: 'roleManageForm',
                        name:'roleManageForm',
                        component: (resolve) => require(['./views/system/role/roleManageForm.vue'], resolve),
                        meta: {
                            title:"角色管理",
                            menu:'roleManage',
                            pname:'roleManageList'
                        }
                    },
                    {
                        path: 'supplierManagement',
                        name:'supplierManagement',
                        component: (resolve) => require(['./views/system/supplierManagement/supplierManagement.vue'], resolve),
                        meta: {
                            title:"供应商管理",
                            menu:'supplierManagement',
                            keepAlive: true
                        }
                    },
                    {
                        path: 'suppierManagementDeatils',
                        name:'suppierManagementDeatils',
                        component: (resolve) => require(['./views/system/supplierManagement/suppierManagementDeatils.vue'], resolve),
                        meta: {
                            title:"供应商管理",
                            menu:'supplierManagement',
                            pname: 'supplierManagement'
                        }
                    },
                    {
                        path: 'secretKeyManage',
                        name:'secretKeyManage',
                        component: (resolve) => require(['./views/system/key/screctKey.vue'], resolve),
                        meta: {
                            title:"秘钥管理",
                            menu:'secretKeyManage',
                            keepAlive: true
                        }
                    },
                    {
                        path: 'screctKeyDetail',
                        name:'screctKeyDetail',
                        component: (resolve) => require(['./views/system/key/screctKeyDetail.vue'], resolve),
                        meta: {
                            title:"登记详情",
                            menu:'secretKeyManage',
                            pname:'secretKeyManage',
                        }
                    },

                    {
                        path: 'secretKeyForm',
                        name:'secretKeyForm',
                        component: (resolve) => require(['./views/system/key/secretKeyForm.vue'], resolve),
                        meta: {
                            title:'秘钥编辑',
                            pname:'secretKeyManage',
                        }
                    },
                    {
                        path: 'projectMaintaining',
                        name:'projectMaintaining',
                        component: (resolve) => require(['./views/system/project/projectMaintaining.vue'], resolve),
                        meta: {
                            title:"项目维护",
                            keepAlive: true
                        }
                    },
                    {
                        path: 'projectEdit',
                        name:'projectEdit',
                        component: (resolve) => require(['./views/system/project/projectMaintaining.vue'], resolve),
                        meta: {
                            title:"项目编辑",
                            keepAlive: true
                        }
                    },
                    {
                        path: 'projectMainDetail',
                        name:'projectMainDetail',
                        component: (resolve) => require(['./views/query/project/projectDetail.vue'], resolve),
                        meta: {
                            title:"项目维护详情",
                            pname:'projectMaintaining',
                        }
                    },
                    {
                        path: 'projectMainForm',
                        name: 'projectMainForm',
                        component: (resolve) => require(['./views/system/project/projectMainForm.vue'], resolve),
                        meta: {
                            title:"项目维护编辑",
                            pname:'projectMaintaining',
                        }
                    },
                    //应对测试环境返回路由projectEdit
                    {
                        path: 'projectMainDetail',
                        name:'projectMainDetail',
                        component: (resolve) => require(['./views/query/project/projectDetail.vue'], resolve),
                        meta: {
                            title:"项目维护详情",
                            pname:'projectEdit',
                        }
                    },
                    //应对测试环境返回路由projectEdit
                    {
                        path: 'projectMainForm',
                        name: 'projectMainForm',
                        component: (resolve) => require(['./views/system/project/projectMainForm.vue'], resolve),
                        meta: {
                            title:"项目维护编辑",
                            pname:'projectEdit',
                        }
                    },
                    {
                      path: 'projectManagement',
                      name:'projectManagement',
                      component:(resolve) => require(['./views/system/project/projectManagement.vue'], resolve),
                      meta: {
                        title:'项目管理',
                        keepAlive: true

                      }
                    },
                    {
                        path: 'projectDelete',
                        name:'projectDelete',
                        component:(resolve) => require(['./views/system/project/projectManagement.vue'], resolve),
                        meta: {
                            title:'项目管理',
                            keepAlive: true
                        }
                    },
                    {
                      path: 'pushFailList',
                      name:'pushFailList',
                      component:(resolve) => require(['./views/system/dataPushFailure/dataPushFailuresList.vue'], resolve),
                      meta: {
                        title:'数据推送失败清单',
                        keepAlive: true
                      }
                    },
                ]
            },
            {
                name: 'warningManage',
                path: '/warningManage',
                redirect:{
                    name:'warningWorkerManage'
                },
                meta: {
                    title: '预警人员管理',
                },
                component: baseContent,
                children: [
                    {
                        path: 'warningWorkerManage',
                        name:'warningWorkerManage',
                        component: (resolve) => require(['./views/system/warningManage/warningWorkerManage.vue'], resolve),
                        meta: {
                            title:"预警人员管理",
                            keepAlive: true
                        }
                    },
                ]
            },
            // 预警管理
            {
                name: "warningManagement",
                path: "warningManagement",
                redirect: {
                    name: "warningSet",
                },
                meta: {
                    title: "预警管理",
                    // requiresAuth: true,
                },
                component: baseLayout,
                children: [
                    {
                        name: "warningSet",
                        path: "warningSet",
                        redirect: {
                            name: "warningSet",
                        },
                        meta: {
                            title: "预警设置",
                        },
                        component: baseContent,
                        children: [
                            //预警设置
                            {
                                path: "warningSet",
                                name: "warningSet",
                                component: (resolve) =>
                                    require(["./views/warningManagement/warningSet.vue"], resolve),
                                meta: {
                                    title: "预警设置",
                                    keepAlive: true,
                                },
                            },
                            //预警消息
                            {
                                path: "warningMessage",
                                name: "warningMessage",
                                component: (resolve) =>
                                    require(["./views/warningManagement/warningMessage.vue"], resolve),
                                meta: {
                                    title: "预警消息",
                                    keepAlive: true,
                                },
                            },
                            //预警详情
                            {
                                path: "alertDetails",
                                name: "alertDetails",
                                component: (resolve) =>
                                    require(["./views/warningManagement/alertDetails.vue"], resolve),
                                meta: {
                                    title: "预警详情",
                                    pname: "warningMessage",
                                },
                            },
                        ]
                    },
                ]
            }
        ]
    },
];
// 路由配置
const RouterConfig = {
    mode: 'history',
    // mode: 'hash',
    base:'/glm/jg/',
    routes: routers,
};
const router = new VueRouter(RouterConfig);
// 动态路由
function recursionRouter(userRouter = [],allRouter = []) {
    /* userRouter 接口返回的菜单 */
    /* allRouter 本地定义的路由 */
    var realRoutes = [];
    userRouter.forEach((item, i) => {
        if(item.iframe){
            let obj = {
                name: item.url,
                path: '/'+item.url,
            };
            switch (item.iframe) {
                case '1':
                    obj.component = baseLayout;
                    break;
                case '2':
                    obj.component = baseContent;
                    break;
                case '3':
                    obj.component = iframe;
                    break;
            }
            if (item.children && item.children.length > 0) {
                item.children = recursionRouter(item.children, []);
                obj.meta = {
                    title: item.name,
                    requiresAuth: true
                };
                obj.redirect = {
                    name:item.children[0].name
                };
                obj.children = item.children;
                obj.children.push({
                    path:'*',
                    component:errorPage,
                    meta: {
                        title:"404"
                    }
                })
            }else {
                obj.meta = {
                    title: item.name,
                };
            }
            realRoutes.push(obj);
        }else {
            allRouter.forEach((all, index) => {
                let isUN=(item.url === all.name); // 判断菜单 url 和路由 name
                let isUP=(item.url === all.meta.pname); // 判断菜单 url 和路由 pname(当前页的详情之类的子页面)
                if (isUN || isUP) {
                    if (item.children && item.children.length > 0) {
                        all.children = recursionRouter(item.children, all.children);
                        all.children.push({
                            path:'*',
                            component:errorPage,
                            meta: {
                                title:"404"
                            }
                        })
                    }
                    realRoutes.push(all);
                }
            });
        }
    });
    return realRoutes;
}
store.dispatch('GetDict');
store.dispatch('GetComfig');
const redirectList = ['/','/login'];   // 需要重定向到系统展示首页 名单
router.beforeEach((to, from, next) => {
    iView.LoadingBar.start();
    Util.title(to.meta.title);
    // 是否登录
    let userId =  localStorage.getItem('userId') || '';
    // 是否需要认证
    const auth = to.matched.some(record => record.meta.requiresAuth);
    // 免登陆操作
    if(params.token) {
        if(userId !== params.userId) {
            // 免登陆用户不同 设置为未登录状态
            userId = '';
        }
    }
    if(userId) {
        // 已登录
        if(store.state.navList && store.state.navList.length ===0 ){
            store.dispatch('GenerateRoutes').then((data=[])=>{
                let arrRouters=recursionRouter(JSON.parse(JSON.stringify(data)) ,asyncRouters);
                // console.log(arrRouters);
                // 动态添加可访问路由表
                router.addRoutes(arrRouters);
                if(redirectList.includes(to.path)) {
                   // 已登录状态从登录页定向到 系统展示首页
                    next({
                        name: 'supervision',
                        replace: true
                    })
                }else {
                    next({  ...to, replace: true })
                }
            }).catch(()=>{
                // 清除缓存 跳转登录页
                store.dispatch('users/clearCache');
                next({
                    name: 'login', // 跳转到登录页
                    query: { redirect: to.path }
                })
            });
        }else {
            next()
        }
    }else {
        // 未登录
        if(params.token) {
            // 检测到免登陆参数
            for(let key in params){
                Vue.cookie.set(key, params[key]);
            }
            store.commit('users/setUser', { ...params, userInfo: JSON.stringify(params) });
            if(redirectList.includes(to.path)) {
                // 是登录页 则跳转到主页面
                next({
                    name: 'supervision',
                    replace: true
                })
            }else {
                next({  ...to, replace: true })
            }

        }else if (!to.query.auth && to.name==='base') {
            authLogin().then((res)=>{
                if(res.data.success){
                    let loginType = Vue.cookie.get('loginType');
                    let userId = Vue.cookie.get('userId');
                    let userName = Vue.cookie.get('userName');
                    store.commit('users/setUser',{
                        loginType: loginType,
                        userId: userId,
                        userName: userName,
                        token: res.data.data,
                    });

                    next({
                        name:'base',
                        query: { auth: 'base' }
                    });
                }else {
                    next({
                        name: 'login', // 跳转到登录页
                        query: { redirect: to.path }
                    })
                }
            }).catch((err)=>{
                store.dispatch('users/clearCache');
                next({
                    name: 'login', // 跳转到登录页
                    query: { redirect: to.path }
                })
            })
        }else {
            if(auth || !to.name){
                // 要跳转的页面需要登录
                next({
                    name: 'login', // 跳转到登录页
                    query: { redirect: to.path }
                })
            }else {
                next() // 跳转
            }
        }
    }
});

router.afterEach(() => {
    iView.LoadingBar.finish();
    window.scrollTo(0, 0);
});

export default router;
